import React, { Component } from 'react';
import './PagePadding.scss';

class PagePadding extends Component {
	render() {
		return (
			<div className="PagePadding">{this.props.children}</div>
		);
	}
}

export default PagePadding;
